import axios from 'axios'
import { isNull, isUndefined } from 'lodash'
import { formToJSON, triggerChange } from '../misc/Utils'
import Swal from 'sweetalert2'

export default class ProductCartForm {
    constructor() {
        this.checkout = false
        this.cacheDom()
        this.bindEvents()
    }

    cacheDom() {
        this.selectedOptions = { size: null, colour: null }
        this.productJson = document.getElementById('productJson')
        this.product = JSON.parse(this.productJson.innerHTML)
        this.options = document.querySelectorAll('.product-options')

        this.quantity = document.getElementById('quantity')
        this.cartForm = document.getElementById('cart-form')
        this.checkoutButton = document.getElementById('checkout-button')
        this.increaseQuantity = document.querySelector('.product-quantity .add')
        this.decreaseQuantity = document.querySelector('.product-quantity .subtract')
        this.swatchWraps = document.querySelectorAll('.product-swatch-wrap')
        this.select = document.querySelectorAll('.select-options')
        this.stroke = document.querySelector('.stroke')

        this.disclaimerButton = document.querySelectorAll('.product-cart__disclaimer-more')
    }

    bindEvents() {
        if (!isNull(this.options)) {
            Array.prototype.forEach.call(this.options, (element) => {
                element.addEventListener('change', this.onChange.bind(this))
            })

            Array.prototype.forEach.call(this.select, (element) => {
                element.addEventListener('change', this.onChange.bind(this))
            })

            Array.prototype.forEach.call(this.swatchWraps, (element) => {
                this.handleSwatchWraps(element)
            })
        }

        if (!isNull(this.disclaimerButton)) {
            this.disclaimerButton.forEach((button) => button.addEventListener('click', this.handleTruncate.bind(this)))
        }

        this.increaseQuantity.addEventListener('click', this.handleQuantity.bind(this))
        this.decreaseQuantity.addEventListener('click', this.handleQuantity.bind(this))
        this.cartForm.addEventListener('submit', this.handeCartForm.bind(this))
        this.checkoutButton.addEventListener('click', () => this.checkout = true)
    }

    onChange(event) {
        const option = event.target
        const key = event.target.name
        const value = event.target.value
        this.selectedOptions[key] = value

        const options = Object.values(this.selectedOptions).flat()
        this.handleSelection(options)

        if (option.closest('.product-swatch-options')) {
            const swatches = option.closest('.product-swatch-options').querySelectorAll('li')
            swatches.forEach((swatch) => swatch.classList.remove('is-checked'))
        }

        if (option.checked) {
            option.closest('li').classList.add('is-checked')       
        }

        if (this.stroke) {
            this.switchStroke(option)
        }
    }

    handleSwatchWraps(element) {
        const inputs = element.querySelectorAll('input')
        const selected = element.querySelector('input:checked')

        console.log(selected)

        if (selected) {
            triggerChange(selected)

            return
        }

        inputs[0].checked = true
        triggerChange(inputs[0])
    }

    handleSelection(options) {
        const product = this.product.variants.find((variant) => {
            return variant.options.every((item) => options.includes(item))
        })

        if (isUndefined(product)) {
            this.handleNotFound()
        } else {
            if (product.available) {
                this.handeInStock(product)
            } else {
                this.handleOutOfStock()
            }
        }
    }

    handeInStock(product) {
        const price = document.querySelector('.product-price')
        const button = document.querySelector('.btn-add-to-cart')
        const buttonLabel = document.querySelector('.btn-text')
        const id = document.querySelector('[name="id"]')

        id.value = product.id
        price.innerHTML = `&pound;${product.price / 100}`

        if (product.available) {
            button.classList.remove('is-disabled')
            buttonLabel.innerHTML = 'add to bag'
        }
    }

    handleOutOfStock() {
        const button = document.querySelector('.btn-add-to-cart')
        const buttonLabel = document.querySelector('.btn-text')
        button.classList.add('is-disabled')
        buttonLabel.innerHTML = 'Out of stock'
    }

    handleNotFound() {
        const button = document.querySelector('.btn-add-to-cart')
        const buttonLabel = document.querySelector('.btn-text')
        button.classList.add('is-disabled')
        buttonLabel.innerHTML = 'add to bag'
    }

    handleQuantity(event) {
        if (event.target.classList.contains('add')) {
            this.quantity.value = this.quantity.valueAsNumber + 1
        } else {
            this.quantity.value = this.quantity.value == 0 ? 0 : this.quantity.valueAsNumber - 1
        }
    }

    handeCartForm(event) {
        event.preventDefault()

        const inputs = event.target.querySelectorAll('input')
        const button = document.querySelector('.btn-add-to-cart')
        const checkoutButton = this.checkoutButton
        const data = formToJSON(inputs)

        button.disabled = true
        checkoutButton.disabled = true

        const payload = {
            items: [
                {
                    id: parseInt(data.id),
                    quantity: parseInt(data.quantity),
                },
            ],
        }

        axios
            .post('/cart/add.js', payload)
            .then((response) => {
                events.publish('cart')

                if (this.checkout) {
                    window.location.href = '/checkout';
                }
            })
            .catch((error) => {
                const { description } = error.response.data

                // Revert checkout state
                this.checkout = false

                Swal.fire({
                    title: 'Oops...',
                    text: description,
                    icon: 'error',
                })
            })
            .finally(() => {
                button.disabled = false
                checkoutButton.disabled = false
            })
    }

    switchStroke(option) {
        const label = option.parentNode
        const stroke = label.getAttribute('data-stroke')

        if (option.name !== 'colour') {
            return
        }
        
        if (isUndefined(stroke) || isNull(stroke)) {
            this.stroke.src = ''
            return
        }
        
        // Update src
        this.stroke.src = stroke
    }

    handleTruncate(event) {
        const button = event.target
        const content = button.nextElementSibling

        if (isNull(button) || isNull(content)) {
            return
        }

        button.style.display = 'none'
        content.style.display = 'inline'
    }
}
